export enum QuotationTypes {
  Offer = 'Angebot',
  AddendumOffer = 'Nachtragsangebot',
}
